import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider, Stack, FormControlLabel, Checkbox, Grid, Button } from '@mui/material';
import { MessageSquareMore, Save } from 'lucide-react';
import ConnectionStatus from './ConnectionStatus';
import ConnectWhatsApp from './ConnectWhatsApp';
import DisconnectWhatsApp from './DisconnectWhatsApp';
import { WhatsAppConnection } from './whatsappTypes';

import SimpleBackdrop from '../../components/Loading/SimpleBackdrop';
import { AlertInfo } from '../../components/Alerts/Alert';
import { api, whatsappWEbApi } from '../../services/api';
import { boolean } from 'yup';

const WhatsAppConfiguration: React.FC = () => {
	const [stringInfoLogin] = useState(sessionStorage.getItem("infoLogin"));
	const [infoLogin] = useState(stringInfoLogin ? JSON.parse(stringInfoLogin) : null);
	const [openLoad, setOpenLoad] = useState<boolean>(false);
	const [connection, setConnection] = useState<WhatsAppConnection>({
		isConnected: false,
	});

	async function handleSaveOptions() {
		setOpenLoad(true);
		try {
			const { session_id, msg_cliente_status_processo } = connection;
			const response = await api.post(`/updatewhatsapp`, { session_id, msg_cliente_status_processo });
			if (response && response.data && response.data.success) {
				AlertInfo({ icon: 'success', title: 'Dados Gravados' });
			} else {
				console.log(response);
				AlertInfo({ icon: 'error', title: response.data.msg });
			}
		} catch (error) {
			console.log(error);
			AlertInfo({ icon: 'error', title: 'Falha na conexão' });
		}
		setOpenLoad(false);
	}

	const handleConnect = (con: WhatsAppConnection) => {
		// In a real application, this would be the result of an API call
		setConnection(con);
	};

	const handleDisconnect = () => {
		// In a real application, this would call an API to disconnect
		setConnection({
			isConnected: false
		});
	};

	const handleLoading = (flag: boolean) => {
		setOpenLoad(flag);
	}

	async function loadData() {
		setOpenLoad(true);
		try {
			let msg_cliente_status_processo = 0;
			const responseApi = await api.get(`/whatsappconnection`);
			console.log(responseApi);
			if (responseApi && responseApi.data) {
				msg_cliente_status_processo = responseApi.data.msg_cliente_status_processo;
			}
			const session_id = 'spj' + infoLogin?.id_escritorio_usuario;
			const response = await whatsappWEbApi.get(`/whatsapp/status/${session_id}`);
			console.log(response); // INJECT AQUI
			if (response && response.data && response.data.status && response.data.status === "connected") {
				const { phone_number, pushname, connected_at } = response.data;
				handleConnect({ msg_cliente_status_processo, phone_number, session_id, isConnected: true, connected_at, name: pushname });
			}
		} catch (error) {
			console.log(error);
			AlertInfo({ icon: 'error', title: 'Falha na conexão' });
		}
		setOpenLoad(false);
	}

	useEffect(() => {
		loadData();
	}, []);

	return (
		<Box>
			<SimpleBackdrop open={openLoad} zIndex={9999} />
			<Stack
				direction="row"
				spacing={1.5}
				alignItems="center"
				sx={{ mb: 2 }}
			>
				<Box
					sx={{
						backgroundColor: '#25D366',
						color: 'white',
						width: 40,
						height: 40,
						borderRadius: 1.5,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<MessageSquareMore size={24} />
				</Box>
				<Typography variant="h5" component="h1" sx={{ fontWeight: 500 }}>
					Integração com WhatsApp
				</Typography>
			</Stack>

			<Typography variant="body1" color="text.secondary">
				Conecte sua conta do WhatsApp para permitir a comunicação com seus clientes diretamente desta plataforma.
			</Typography>

			<Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
				Status da conexão
			</Typography>

			<Box>
				<ConnectionStatus connection={connection} />
			</Box>

			<Box>
				{connection.isConnected ? (
					<DisconnectWhatsApp onDisconnect={handleDisconnect} loading={handleLoading} connection={connection} />
				) : (
					<ConnectWhatsApp onConnect={loadData} />
				)}
			</Box>

			{connection.isConnected && (
				<Box sx={{ mt: 3 }}>
					<Divider>OPÇÕES</Divider>
					<Grid container spacing={1}>
						<Grid item xs={12}>
							<FormControlLabel
								control={
									<Checkbox
										checked={Boolean(connection.msg_cliente_status_processo)}
										onChange={() => setConnection({ ...connection, msg_cliente_status_processo: Number(!connection.msg_cliente_status_processo) })}
									/>
								}
								label="ENVIAR MENSAGEM AO CLIENTE QUANDO O STATUS DO PROCESSO FOR ALTERADO"
							/>
						</Grid>

						<Grid item xs={false} sm={4}></Grid>
						<Grid item xs={12} sm={4}>
							<Button
								variant="contained"
								size="large"
								startIcon={<Save />}
								color='success'
								fullWidth
								onClick={handleSaveOptions}
							>
								SALVAR
							</Button>
						</Grid>
						<Grid item xs={false} sm={4}></Grid>
					</Grid>
				</Box>
			)}
		</Box>
	);
};

export default WhatsAppConfiguration;